


























import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GTemplateCard',
  props: {
    image: { type: String as PropType<string>, required: true },
    templateType: { type: String as PropType<string>, required: true },
    description: { type: String as PropType<string>, required: true },
    recommends: { type: Array as PropType<string[]>, required: true },
    previewEvt: { type: Function as PropType<Function>, required: true },
    createEvt: { type: Function as PropType<Function>, required: true },
    descHeight: { type: Number as PropType<number> },
    recomHeight: { type: Number as PropType<number> },
  },
  mounted() {
    // this.getDescriptionHeight();
    // this.getRecommendHeight();
    // window.addEventListener('resize', this.getDescriptionHeight);
    // window.addEventListener('resize', this.getRecommendHeight);
  },
  methods: {
    getDescriptionHeight() {
      if (this.$refs.templateCardDescription instanceof Element) this.$emit('getDescHeight', this.$refs.templateCardDescription.clientHeight);
    },
    getRecommendHeight() {
      if (this.$refs.templateCardRecommend instanceof Element) this.$emit('getRecomHeight', this.$refs.templateCardRecommend.clientHeight);
    },
  },
});
